module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('menu', {
    staticClass: "menu",
    class: _vm.modifierClass ? ("menu--" + _vm.modifierClass) : '',
    attrs: {
      "data-expand": _vm.expanded || (_vm.isMenuOpen && _vm.isNotSync)
    }
  }, [_c('button', {
    staticClass: "menu__button",
    attrs: {
      "data-acc": _vm.acc
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggle.apply(null, arguments)
      }
    }
  }, [_c('figure', {
    class: _vm.figureClass,
    style: (_vm.image ? ("background-image:url(" + _vm.image + ")") : '')
  }), _vm._v(" "), _c('span', {
    staticClass: "menu__label"
  }, [_vm._v(_vm._s(_vm.label))])]), _vm._v(" "), _c('ul', {
    staticClass: "menu__tray"
  }, _vm._l((_vm.links), function(link) {
    return _c('li', {
      staticClass: "menu__item"
    }, [(!link.bypassRouter) ? _c('router-link', {
      attrs: {
        "to": link.url,
        "data-acc": link.acc
      }
    }, [_vm._v("\n        " + _vm._s(link.label) + "\n      ")]) : (link.asFunction) ? _c('a', {
      attrs: {
        "href": "javascript:void(0)",
        "data-acc": link.acc
      },
      on: {
        "click": function($event) {
          return _vm.throwFunction(link.url)
        }
      }
    }, [_vm._v("\n        " + _vm._s(link.label) + "\n      ")]) : _c('a', {
      attrs: {
        "href": link.url,
        "data-acc": link.acc
      }
    }, [_vm._v("\n        " + _vm._s(link.label) + "\n      ")])], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-42ac4088!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/partials/Dropdown.vue
// module id = 729
// module chunks = 1